import DialogComponent from "../../../components/DialogComponent";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import Button from "src/components/Button";
import { useEffect, useState } from "react";
import { versionsByDocumentListName, versionsCardListName } from "src/api/config";
import { selectUsers } from "src/modules/users/selector";
import { docStatuses } from "src/api/config/systemSwitch";
import { getItemsRequest } from "src/modules/spItems/api";
import { addUsers } from "src/modules/users/actions";
import _ from "lodash";

type Props = {
    open: boolean;
    toggleDialog: any;
    setOpen: any;
    setCloseAllModals: any;
    closeAllModals: any;
    card: any;
}

const ApproveBlockModal = (props: Props) => {

    const { open, toggleDialog, setOpen, setCloseAllModals, closeAllModals, card } = props
    const [userChange, setUserChange] = useState<any>(null);
    const noAddArchive = localStorage.getItem("noAddArchive");
    const users: any = useAppSelector(selectUsers);
    const [versionsDocument, setVersionsDocument] = useState<any>([]);
    const dispatch = useAppDispatch();

    useEffect(() => {
        getItemsRequest({ listName: versionsByDocumentListName, filters: { MainDocument: card.ID } }).then((results) => {
            if (results.items.length > 0) {
                let usersEmail: any = [];
                // @ts-ignore
                results.items.forEach((item: any) => {
                    Object.keys(item).forEach((key) => {
                        const field = item[key];
                        if (field && !Array.isArray(field) && field.get_email) {
                            if (field.get_email()) {
                                usersEmail = [...usersEmail, field.get_email().toLowerCase()];
                            }
                        }
                        if (
                            field &&
                            Array.isArray(field) &&
                            field.length > 0 &&
                            field[0].get_email
                        ) {
                            field.forEach((user) => {
                                if (user.get_email()) {
                                    usersEmail = [
                                        ...usersEmail,
                                        user.get_email().toLowerCase(),
                                    ];
                                }
                            });
                        }
                    });
                });
                usersEmail = _.uniqWith(usersEmail, _.isEqual);
                if (usersEmail.length > 0) {
                    let actualEmails: any = [];
                    usersEmail.forEach((item: string) => {
                        let check = false;
                        Object.keys(users).forEach((key) => {
                            if (key === item) {
                                check = true;
                            }
                        });
                        if (!check) {
                            actualEmails = [...actualEmails, item.toLowerCase()];
                        }
                    });
                    if (actualEmails) {
                        dispatch(addUsers(actualEmails));
                    }
                }
            }
            setVersionsDocument([...results.items]);
        });
    }, [card]);

    useEffect(() => {
        if (versionsDocument.find((version: any) => version.Status.get_lookupId() === docStatuses.approval) || versionsDocument.find((version: any) => version.Status.get_lookupId() === docStatuses.revision) || versionsDocument.find((version: any) => version.Status.get_lookupId() === docStatuses.cancel)) {
            versionsDocument.forEach((version: any) => {
                if (version.Status.get_lookupId() === docStatuses.approval || version.Status.get_lookupId() === docStatuses.revision || version.Status.get_lookupId() === docStatuses.cancel) {
                    let name = version.AuthorEmail && users[version.AuthorEmail.trim().toLowerCase()] && users[version.AuthorEmail.trim().toLowerCase()]['displayName'] || "";
                    setUserChange({ name, email: version.AuthorEmail });
                }
            });
        }
    }, [versionsDocument, users]);

    return (
        <DialogComponent open={open} toggleDialog={toggleDialog}>
            <div className="removeElement">
                <span className="block text-[24px] mb-[18px] leading-7.5 font-semibold">{noAddArchive && "Невозможно архивировать документ" || "Невозможно отправить на согласование"}</span>
                <span className="block text-[16px] leading-[22px] mb-[38px]">
                    {userChange && Object.keys(userChange).length > 0 &&
                        <>
                            <strong><a href={`mailto:${userChange.email}`}>{userChange.name}</a></strong> уже создал новую версию документа.<br />Чтобы проверить её статус, внести правки или отправить на согласование — <br />откройте новую версию на вкладке "Версии".
                        </>
                    }
                </span>
                <div className="divide-y mb-[40px] h-px border-t" />
                <div className="flex justify-center">
                    <div className="mr-5">
                        <Button
                            classBg="btn-white"
                            shadow={true}
                            text="Понятно"
                            customFunction={setCloseAllModals}
                            paramsCustomFunction={closeAllModals}
                            open={open}
                            setOpen={setOpen}
                        />
                    </div>
                </div>
            </div>
        </DialogComponent>
    );
};

export default ApproveBlockModal;
